import React from 'react'
import { Modal } from '@/shared/ui'
import { useOportunidadeDetails } from '../hooks/useOportunidadeDetails'
import NearBreakCard from './NearBreakCard'

export default function OportunidadeDebugModal({ open, onOpenChange, item }: { open: boolean; onOpenChange: (v:boolean)=>void; item: any }) {
  const { data, asset, loading, error } = useOportunidadeDetails(item)
  return (
    <Modal open={open} onOpenChange={onOpenChange} className="w-[70vw] max-w-none h-[85vh]">
      <div className="space-y-3">
        <div className="text-base font-semibold">Debug técnico</div>
        {error && <div className="rounded-md border border-destructive/30 bg-destructive/10 p-2 text-sm text-destructive-foreground">{error}</div>}
        {loading && <div className="text-sm text-foreground/70">Carregando...</div>}
        {!loading && (
          <div className="grid grid-cols-2 gap-3">
            <div className="col-span-2">
              {/* Exibe card de proximidade (ou exemplo quando ausente) */}
              <NearBreakCard data={data} exampleWhenEmpty />
            </div>
            <div className="flex min-h-0 flex-col">
              <div className="mb-1 text-sm font-medium">confluence_factors</div>
              <pre className="h-[70vh] min-h-0 flex-1 overflow-auto rounded-md bg-muted/20 p-3 text-xs leading-relaxed">{JSON.stringify((data as any)?.confluence_factors ?? (data as any)?.confluence ?? null, null, 2)}</pre>
            </div>
            <div className="flex min-h-0 flex-col">
              <div className="mb-1 text-sm font-medium">Registro bruto</div>
              <pre className="h-[70vh] min-h-0 flex-1 overflow-auto rounded-md bg-muted/20 p-3 text-xs leading-relaxed">{JSON.stringify(data, null, 2)}</pre>
            </div>
          </div>
        )}
      </div>
    </Modal>
  )
}
